export default "__VITE_ASSET__0UA$AJQX__"